import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { InsertSystemSettingsMutation, InsertSystemSettingsMutationVariables } from '@/graphql/generated/graphql';
import { InsertSystemSettingsDocument } from '@/graphql/generated/graphql';
export type SystemSettingsInsertInput = {
  OrganizationIds?: string[]
  Key: string
  Value: string
  Description: string
}

export type SystemSettingsInsertResponse = {
  data: {
    insertSystemSettings: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useInsertSystemSettings = () => {
  const mutation = useMutation({
    mutationKey: ['insert-system-settings'],
    mutationFn: (variables: SystemSettingsInsertInput) => {
      return graphqlClient.request<InsertSystemSettingsMutation>(InsertSystemSettingsDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    insertSystemSettings: mutation.mutate,
    insertSystemSettingsAsync: mutation.mutateAsync,
  }
}

export const INSERT_SYSTEM_SETTING_MUTATION = InsertSystemSettingsDocument;
